module.exports = __webpack_public_path__ + "9af9ef80208a7023d9e1a59736e72580.jpg";